import {
    useState,
} from 'react'
import FormWithControls from 'app/shared-components/FormWithControls'
import useEnumValues from 'app/hooks/useEnumValues'
import useFieldsWithClassNames from 'app/hooks/useFieldsWithClassName'
import useValidation from 'app/hooks/useValidation'
import {
    RequestConfig,
} from 'app/types/request.types'
import {
    SimplifiedCQuote,
} from '../SimplifiedCQuotes.types'
import getFields from './SimplifiedCQuoteForm.fields'
import useStyles from './SimplifiedCQuoteForm.styles'

const defaultProps = {
    shortenMode: false,
    disabled: false,
    onSuccess: undefined,
    onCancel: undefined,
    requestParam: undefined,
    data: undefined,
}

export default function SimplifiedCQuoteForm({
    shortenMode,
    disabled,
    onSuccess,
    data,
    requestParam,
    onCancel,
}: Readonly<{
    shortenMode?: boolean,
    disabled?: boolean,
    onSuccess?: (...args: any[]) => void,
    data?: SimplifiedCQuote,
    requestParam?: RequestConfig,
    onCancel?: (...args: any[]) => void,
}>) {
    const [
        value,
        setValue,
    ] = useState(data)
    const {
        classes,
    } = useStyles({
        shortenMode,
    })
    const getAllowedValues = useEnumValues()
    const fields = useFieldsWithClassNames(getFields({
        shortenMode,
        disabled,
        getAllowedValues,
        originCountry: value?.originCountry?.id,
        destinationCountry: value?.destinationCountry?.id,
    }), classes)

    const {
        isValid,
    } = useValidation({
        fields, values: value,
    })

    return (
        <FormWithControls
            isValid={isValid}
            setExternalValue={setValue}
            onSuccess={onSuccess}
            value={value}
            name="SimplifiedCQuote"
            fields={fields}
            requestParams={requestParam}
            exists={!!data?.id}
            onCancel={onCancel}
            disabled={disabled}
            classNames={{
                gridWrapper: classes.gridWrapper,
            }}
        />
    )
}

SimplifiedCQuoteForm.defaultProps = defaultProps
